import './components';

import { handlePopupClose } from '../../auto/utils/components/pop-up';
import { setDropdownInteration } from '../../auto/utils/components';
import equalHeights from '../../auto/utils/equalHeights';
import privacyPolicyPopup from '../../auto/privacyPolicyPopup';
import serviceConversionFactory from '../../auto/autoBoxOfficeServiceFactory';
import helpers from '../../auto/helpers';
import { createCookieUTM } from '../../auto/utils/utm';
import { createGADCookie } from '../../auto/utils/gadTracking';
import { createFbclidCookie } from '../../auto/utils/fbclid';
import { initSectionWhenItIsVisible } from '../../auto/utils/initSectionWhenItIsVisible';
import { initSectionWhenUserInteracts } from '../../auto/utils/initSectionWhenUserInteracts';
import hookConversion from '../../auto/utils/hookConversion';

createCookieUTM();
createGADCookie();
createFbclidCookie();

window.helpers = {
  ...helpers,
  initSectionWhenItIsVisible,
  initSectionWhenUserInteracts,
};
window.serviceConversion = serviceConversionFactory();
window.components = {
  setDropdownInteration,
};
window.matchHeight = {
  match: equalHeights,
};

window.privacyPolicyPopup = privacyPolicyPopup;

window.hookConversion = hookConversion;

handlePopupClose();
